import { Investment_IdeaCategory as IdeaCategory } from '../../__generated__/globalTypes';

export enum IdeaFilterOption {
  All = 'All',
  IPO = 'IPO',
  OTC = 'OTC',
  Packs = 'Packs',
  PreIPO = 'PreIPO',
}

export const filterOptionToCategory: { [key in IdeaFilterOption]: IdeaCategory[] } = {
  [IdeaFilterOption.All]: Object.keys(IdeaCategory) as IdeaCategory[],
  [IdeaFilterOption.IPO]: [IdeaCategory.IPO],
  [IdeaFilterOption.PreIPO]: [IdeaCategory.PRE_IPO],
  [IdeaFilterOption.OTC]: [IdeaCategory.OTC],
  [IdeaFilterOption.Packs]: [IdeaCategory.STRATEGY_PACK, IdeaCategory.CRYPTO],
};
